import { Pipe, PipeTransform } from '@angular/core';

/**
 * utilities
 */
import { truncate } from '@core/utilities';

/**
 * @pipe TruncatePipe
 * @description
 * Angular pipe to truncate a string to the defined length with ellipsis if needed.
 * @example
 * {{ 'Hello, world!' | truncate:10 }}
 */
@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  /**
   * @param value - The string to truncate
   * @param length - The length to truncate the string to
   * @returns The truncated string
   * @default 10
   * @example
   * {{ 'Hello, world!' | truncate }}
   * <!-- returns 'Hello, world!' -->
   * 
   * @example
   * {{ 'Hello, world!' | truncate: 20 }}
   * <!-- returns 'Hello, wor...' -->
   * 
   */
  transform(value: string = '', length?: number): string {

    // void
    if (!value || value == null) return '';

    // validation
    // throw error if length is not provided
    if (length == null) {
      throw new Error('length is required');
    }

    // return truncated string
    return truncate(value, length);
  }

}
